import { render, staticRenderFns } from "./MotionBackgroundColor.vue?vue&type=template&id=6e0fd9c2"
import script from "./MotionBackgroundColor.vue?vue&type=script&lang=js"
export * from "./MotionBackgroundColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports